import { TINYMCE_CLOUD_API_KEY } from '../../constants';
import { getTinyMceFontFormats } from '../../utils/font.utils';

export const TINYMCE6_PLUGIN_OPTS = {
  'tinymce-module': `https://cdn.tiny.cloud/1/${TINYMCE_CLOUD_API_KEY}/tinymce/6/tinymce.min.js`,
  inline: ['span', 'a', 'button', 'h1', 'h2', 'h3', 'h4', 'h5', 'label'],
  inline_toolbar: ['bold italic underline strikethrough forecolor backcolor', 'fontfamily fontsize'],
  toolbar: [
    'bold italic underline strikethrough fontfamily fontsize outdent indent blocks forecolor backcolor | alignleft aligncenter alignright alignfull | numlist bullist',
  ],
  plugins: ['link', 'lists', 'autolink'],
  font_family_formats: getTinyMceFontFormats(true),
  toolbar_offset_y: 40,
} as const;
